import React, { useEffect, useRef, useState } from 'react';
import { usePermissions } from '../contexts/permissionsContext';
import { useRouteChange } from '../contexts/routeChangeContextProvider';
import useAuth from '../hooks/useAuth';
import SimpleBackdrop from './loading/loading';

/**
 * @function RouteChangeLoading
 * @description Componente de loading para rota de mudança com atualização de permissões
 * @returns {JSX.Element} - Componente de loading
 */
const RouteChangeLoading = () => {
    const { isLoading, setIsLoading } = useRouteChange();
    const { clearCacheAndRefresh } = usePermissions();
    const { signed } = useAuth();
    const [isRefreshingPermissions, setIsRefreshingPermissions] = useState(false);
    const clearCacheAndRefreshRef = useRef(clearCacheAndRefresh);
    const inFlightRef = useRef(false);

    clearCacheAndRefreshRef.current = clearCacheAndRefresh;

    useEffect(() => {
        if (!isLoading) return undefined;
        if (inFlightRef.current) return undefined;

        if (!signed) {
            setIsLoading(false);
            return undefined;
        }

        let cancelled = false;
        inFlightRef.current = true;

        const refreshPermissions = async () => {
            try {
                setIsRefreshingPermissions(true);
                await clearCacheAndRefreshRef.current();
            } catch (error) {
                console.error('Erro ao atualizar permissões:', error);
            } finally {
                if (!cancelled) {
                    setIsRefreshingPermissions(false);
                    setIsLoading(false);
                }
                inFlightRef.current = false;
            }
        };

        refreshPermissions();

        return () => {
            cancelled = true;
        };
    }, [isLoading, setIsLoading, signed]);

    return (
        <SimpleBackdrop
            open={isLoading || isRefreshingPermissions}
            title="Carregando informações..."
        />
    );
};

export default RouteChangeLoading;
